import SceneProperties from "../data/SceneProperties";

function PlayAudio(id: string, volume = 1.0) {
    if (SceneProperties.isMute) return;

    const music = document.getElementById(id) as HTMLAudioElement;
    if (music != null) {
        music.volume = volume;
        music.play();
    }
}

export default PlayAudio;
